export default __webpack_public_path__ + "static/media/lapis.07754799.png";